const isOffline = (): boolean => {
  return typeof navigator !== 'undefined' && !navigator.onLine;
};

export default isOffline;
